export enum SidebarTypes {
    Navigation = "Navigation",
    LanguageMenu = "LanguageMenu",
}
